import React from 'react'
import MoverCamionDeCalle from '../components/egresoCalado/MoverCamionDeCalle'
import AutodescargableEnCalado from '../components/egresoCalado/AutodescargableEnCalado'

export const COLUMNS_CAMIONES_CALADO_EN_PLAYA = [
  {
    name: 'camion',
    label: 'Camión',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'calleDeCalado',
    label: 'Calle',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'cea',
    label: 'Autodescargable',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (cea) => {
        return <AutodescargableEnCalado cea={cea} />
      }
    }
  },
  {
    name: 'cea',
    label: ' ',
    options: {
      print: false,
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: cea => {
        return <MoverCamionDeCalle cea={cea} />
      }
    }
  }
]
